module.exports = __webpack_public_path__ + "img/贴标机.2c9a4415.png";